<template>
  <div class="rank-master-list-container" ref="rank-master-list">
    <van-list
      class="van-clearfix"
      v-model="loading"
      :finished="finished"
      finished-text=""
      @load="onLoad2"
    >
      <rank-master-item
        v-for="(article, index) in masterList.slice(3)"
        :key="index"
        :rank="index + 4"
        :article="article"
      />
    </van-list>
  </div>
</template>

<script>
import RankMasterItem from '@/views/Rank/components/rank-master-item'
import { debounce } from 'lodash'

export default {
  name: 'RankMasterList',
  components: {
    RankMasterItem
  },
  props: {
    masterList: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      // masterList: [],
      loading: false, // 控制加载中的 loading 状态
      finished: false, // 控制加载结束的状态，当加载结束，不再触发加载更多
      scrollTop: 0 // 列表滚动到顶部的距离
    }
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    const articleList = this.$refs['rank-master-list']
    articleList.onscroll = debounce(() => {
      this.scrollTop = articleList.scrollTop
    }, 50)
  },
  activated() {
    // 把记录的到顶部的距离重新设置回去
    this.$refs['rank-master-list'].scrollTop = this.scrollTop
  },
  methods: {
    async onLoad2() {
      this.loading = false
      this.finished = true
    }
  }
}
</script>

<style lang="less" scoped>
.rank-master-list-container {
  display: block;
  width: 100%;
  height: 100%;
  background-color: transparent;
}
</style>
